<mat-form-field>
  <mat-label>{{ formatTitle.singular }} Name</mat-label>
  <input
    [readonly]="readonly"
    data-cy="deal-name-field"
    matInput
    [placeholder]="'Enter ' + formatTitle.singular.toLowerCase() + ' name'"
    [formControl]="title"
    (blur)="searchSimilarItems()"
    (keyup.enter)="searchSimilarItems()"
  />
</mat-form-field>
<ng-container *ngIf="similarItems$ | async as similarItems">
  <mat-hint *ngIf="similarItems.length">
    <p>One or more {{ formatTitle.plural }} with a similar name already exists:</p>
    <app-similar-items-list
      [similarItems]="similarItems"
      [relatedToType]="relatedToType"
      (onNavigate)="navigateTo($event)"
    ></app-similar-items-list>
  </mat-hint>
</ng-container>
